import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { ToastContainer } from "react-toastify";

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Disabled from './panel/Disabled';
import Uploaddocuments from './panel/Uploaddocuments';
import Notfound from './panel/Notfound';

import Paymentallocation from './components/payroll/Paymentallocation';
import Payslip from './components/payroll/Payslip';
import Staffattendance from './components/payroll/Staffattendance';
import Advancepayment from './components/payroll/Advancepayment';
import Monthlypayments from './components/payroll/Monthlypayments';
import Usersmgmt from './panel/Usersmgmt';
import Attendnacereport from './components/payroll/Attendnacereport';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });


  return (
    <div className="wrapper">
      <Router>

        {
          !user ?
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              {/* <Route path='/Register' element={<Register />} /> */}
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
            :
            <>
              <Header />
              <Menu />
              <div className='content-wrapper p-2' style={{ marginBottom: 50 }}>
                <Routes>

                  <Route path="/attendance-report" element={<Attendnacereport />} />
                  <Route path="/users-mgmt" element={<Usersmgmt />} />
                  <Route path="/payment-allocation" element={<Paymentallocation />} />
                  <Route path="/payslips" element={<Payslip />} />
                  <Route path="/attendance" element={<Staffattendance />} />
                  <Route path="/advance-payment" element={<Advancepayment />} />
                  <Route path="/monthly-payment" element={<Monthlypayments />} />
                  {/* <Route path="/staff-payment-report" element={<Staffpayreport />} /> */}
    
                  <Route path='*' element={<Notfound />} />
                  <Route path='/' element={<Dashboard />} />
                  <Route path='/home' element={<Dashboard />} />
                  <Route path='/disabled-property' element={<Disabled />} />
                  <Route path='/property-documents' element={<Uploaddocuments />} />
                </Routes>

              </div>
              <Footer />
            </>
        }
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div >
  );
}

export default App;
